import React from 'react'
import Error_1 from '../../../assets/images/home_page_4/error/01.png'
import { Link } from 'react-router-dom'

const errors = () => {
  return (
    <>
      <section id="error" className="error-main-block">
        <div className="container">
          <div className="row">
            <div className="error-block">
              <div className="error-img text-center">
                <img
                  src={Error_1}
                  className="img-fluid"
                  alt=""
                />
                <div className="error-dtls">
                  <h1 className="error-title">Oops... Page Not Found!</h1>
                  <p>Sorry! This Page Is Not Available!</p>
                </div>
                <Link to="/" title="" className="btn btn-primary">
                  Go Back To Home Page <i className="flaticon-right-arrows" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default errors
